module.exports = __webpack_public_path__ + "static/media/expo-4-1-caption.eedecd49.svg";